import type { FaireProductEntity } from "../../entity_types/product";

export const p_p27kwudfsc: FaireProductEntity = {
  token: "p_p27kwudfsc",
  type: "product",
  name: "Pasta Slut Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/71e243bc3cb6280dbb150853039357eecad0d03ddc3cb1c23c8b27ffca28f013.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b070e0ae2d140427428dba4b9b6aa83780b5cbae20afa07cfb5c69ea35dd7cf.jpeg",
    "https://cdn.faire.com/fastly/f237cf35b12bc3dde1b41c35ea19cd9fda1ab33dcadea693a494327cec8c4c83.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/ac288d83dc600ac8530ca90f6ed1768aeda5af3a9480d969afd98fcb3e8029f5.jpeg",
    "https://cdn.faire.com/fastly/e8794a04c8bc7ec76a436c48140cfdeb9f635fab7db32311fa5a98c6d32158a4.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you know farfalle has the range and bucatini deserves better PR, you deserve these socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:10.158Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
